import { useQuery } from '@tanstack/react-query'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { throwIfApiError } from '@omnea-app/packages/universal/error-handling/throwifApiError'
import { UsersHttpClient } from '@omnea-app/users/usersHttpClient'

export const getGroupMembersQueryKey = (groupId: string | undefined) => ['getGroupMembers', groupId]

interface UseGetGroupMembersOptions {
  groupId: string | undefined
  enabled?: boolean
}

export const useGetGroupMembers = ({ groupId, enabled = true }: UseGetGroupMembersOptions) => {
  const { getToken } = useAuthenticatedUser()

  return useQuery({
    queryKey: getGroupMembersQueryKey(groupId),
    queryFn: async () => {
      if (!groupId) return { members: [] }

      const token = await getToken()
      const apiClient = new UsersHttpClient({ omneaJwt: token })
      const { data, error } = await apiClient.GET('/groups/{groupId}/members', {
        params: { path: { groupId } },
      })
      // Without this a failed load resolves as undefined, which callers render as an empty group.
      throwIfApiError(error)

      return data
    },
    enabled: enabled && Boolean(groupId),
  })
}
